import ClickAwayListener from 'react-click-away-listener';
import styles from './styles.module.scss';

import cn from 'classnames';

/*
Любое окно которое открывается с анимацией при нажатии на кнопку, иконкую. Позицинируется относительно
родиетльского элемента (должно быть задано свойсвто position: relative) c помощью left, right, top, bottom
*/
export default function DropDown({ close = () => { }, ...props }) {
  const handleClickAway = () => {
    close();
  };

  return (
    <div
      onClick={e => {
        e.stopPropagation();
      }} /* при нажатии внутри он не закрывается */
      className={cn(styles.drop_down, styles.animate, styles.slideIn, props.styles)}
      style={props.style}
    >
      <ClickAwayListener onClickAway={handleClickAway}>
        <div style={{ position: 'relative' }}>{props.children}</div>
      </ClickAwayListener>
    </div>
  );
}
